var map = {
	"./bitharvest/DigitalAssets.vue": [
		"8f0e",
		"chunk-35684aa3",
		"chunk-0cd1d3a5",
		"chunk-4ee68a50",
		"chunk-d70f900e"
	],
	"./oripay/DigitalAssets.vue": [
		"b399",
		"chunk-35684aa3",
		"chunk-0cd1d3a5",
		"chunk-4ee68a50",
		"chunk-5b8f0a5a",
		"chunk-102297f1"
	],
	"./touareg/DigitalAssets.vue": [
		"54ff",
		"chunk-35684aa3",
		"chunk-0cd1d3a5",
		"chunk-4ee68a50",
		"chunk-5b8f0a5a",
		"chunk-103d190b"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "eddf";
module.exports = webpackAsyncContext;